import { render, staticRenderFns } from "./HeritageTree.vue?vue&type=template&id=87b8a2e0&scoped=true"
import script from "./HeritageTree.vue?vue&type=script&lang=ts"
export * from "./HeritageTree.vue?vue&type=script&lang=ts"
import style0 from "./HeritageTree.vue?vue&type=style&index=0&id=87b8a2e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b8a2e0",
  null
  
)

export default component.exports